import React,{useRef, useState, useEffect} from 'react';
import * as S from './UpdateEmail.styles';
import OTPBlock from '../../../../../../../../onboarding/src/stories/components/UI/OTP/otp';
import {useSelector } from 'react-redux';
import {createSelector} from 'reselect';
import {sendEvarData} from '@ibibo/analytics';
import ButtonLoader from '../../../../../../../../onboarding/src/stories/components/UI/Loader/Loader';
import {validations} from '../../../../../../utils/validations';

const UpdateEmail = ({closePop, userEmail, errorEmailText, resentEmailOtp, clickEmailActive, submitEmailOtp, sendEmailOtp, btnLoad, existingEmail, showNewEmailInput, newEmail}) => {
    const otpRef = useRef(null);

    const submitUserOtp = (event: React.FormEvent) => {
        event.preventDefault();
        const otpStr = otpRef.current.value;
        submitEmailOtp(otpStr);
        sendEvarData({
            prop54: "updateEmail_verify"
        }, true)
    }

    const [showEdit, setShowEdit] = useState(false);
    const [errors, setError] = useState({});
    const [email, setEmailId] = useState(userEmail);
    const [showEmail, setShowEmail] = useState(existingEmail);
    const [showError, setShowError] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const editEmail = () => {
        setShowEdit(!showEdit);
        setShowError('');
    }

    useEffect(() => {
        if(errorEmailText !== ''){
            setShowError(errorEmailText);
            setButtonDisabled(true);
        }
    }, [errorEmailText])
    
    useEffect(() => {
        setShowEmail(existingEmail);
    },[existingEmail])
    
    const fieldValidators = {
        'email': {'field': 'email', 'fieldName': 'Email', 'validators': ['required', 'validEmail']},
    };
    
    const validateFields = (data) => {
        let errorObj = {};
        setError({});
        Object.keys(data).map(key => {
            if (fieldValidators[key]) {
            const validators = fieldValidators[key].validators;
            for (let i = 0; i < validators.length; i++) {
                const validateFunction = validations[validators[i]];
                const resp = validateFunction({
                value: data[key],
                fieldName: fieldValidators[key].fieldName,
                });
                if (resp && !errorObj[key]) {
                errorObj[key] = resp;
                }
            }
            }
        });
        setError(errorObj);
        if (Object.keys(errorObj).length) {
            return true;
        }
        return false;
    }

    const onChangeHandler = (field, value) => {
        setEmailId(value);
        setButtonDisabled(false);
    }

    const sendOtp = (event: React.FormEvent) => {
        event.preventDefault();
        const data = email;
        const hasError = validateFields(data);
        if(!hasError){
            sendEmailOtp(data);
            setShowEdit(false);
            setShowError('');
        }
        sendEvarData({
            prop54: "updateEmail__click"
        }, true)
    }

    return(
        <S.EmailVerifyPopWrap>
            <S.EmailVerifyPopContentWrap>
                <S.EmailVerifyPopHeadWrap>
                    <S.PopBackBtn onClick={closePop}>Close</S.PopBackBtn>
                </S.EmailVerifyPopHeadWrap>
                <S.EmailVerifyBodyWrap>
                    {!showNewEmailInput && (
                        <S.VerifyForm onSubmit={submitUserOtp}>
                            <S.EmailVerifyBodyHeadWrap>
                                <S.EmailVerifyMainText>Verify E-mail Address</S.EmailVerifyMainText>
                                <S.EmailVerifyInfoWrap>
                                    <S.EmailVerifyInfoText>We have sent a verification OTP  to : <strong> {newEmail ? newEmail : userEmail}</strong></S.EmailVerifyInfoText>
                                    {/*<S.EmailVerifyEditBtn onClick={editEmail}>Edit</S.EmailVerifyEditBtn>*/}
                                </S.EmailVerifyInfoWrap>
                                <S.OptBlockWrap>
                                    <OTPBlock
                                        ref={otpRef}
                                        label=""
                                        subLabel=""
                                        otpLength={6}
                                        type="aadhar_number"
                                        resendOTP = {() => resentEmailOtp()}
                                        autoFocus={true}
                                        resendVisible={clickEmailActive}
                                    />
                                    {(showError && <S.ErrorText>{showError}</S.ErrorText>) || null}
                                    <S.VerifyInfoText>*Note: Upon verification, all the myPartner communication will be sent to {newEmail ? newEmail : userEmail}</S.VerifyInfoText>
                                </S.OptBlockWrap>
                                <S.OtpFooterBtnWrap>
                                    <S.CancelBtn onClick={closePop}>Cancel</S.CancelBtn>
                                    <S.SubmitBtn type="submit">{btnLoad ? <ButtonLoader loaderType="button"/> : 'Verify'}</S.SubmitBtn>
                                </S.OtpFooterBtnWrap>
                            </S.EmailVerifyBodyHeadWrap> 
                        </S.VerifyForm> 
                    ) || (
                        <S.VerifyForm onSubmit={sendOtp}>
                            <S.EmailVerifyBodyHeadWrap>
                                <S.EmailVerifyMainText>Enter New Email Address</S.EmailVerifyMainText>
                                <S.InputWrap>
                                    <S.CommonInput 
                                        type="text"
                                        placeholder="New Email Address"
                                        name="email"
                                        value={email}
                                        onChange={event => onChangeHandler('email', event.target.value)}
                                        hasError={errors['email'] ? true : false}
                                    />
                                </S.InputWrap>
                                {(newEmail && showError && <S.ErrorText>{showError}</S.ErrorText>) || null}
                                <S.OtpFooterBtnWrap>
                                    <S.CancelBtn onClick={closePop}>Cancel</S.CancelBtn>
                                    <S.SubmitBtn type="submit" disabled={buttonDisabled}>{btnLoad ? <ButtonLoader loaderType="button"/> : 'Send otp'}</S.SubmitBtn>
                                </S.OtpFooterBtnWrap>
                            </S.EmailVerifyBodyHeadWrap>
                        </S.VerifyForm>
                    )}
                </S.EmailVerifyBodyWrap>
            </S.EmailVerifyPopContentWrap>
        </S.EmailVerifyPopWrap>
    )
}

export default UpdateEmail;